module.exports = __webpack_public_path__ + "media/images/Adherent-hover-3b4947b888930c3f91542a40e751a0d9.png";